import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_ORDER = ["nye", "australia-day", "boxing-day", "vivid"];

/**
 * Fetches the admin-managed order of the 4 Ticketed Cruises on the home page.
 * Falls back to DEFAULT_ORDER if the API call fails so the page never breaks.
 */
export default function useHomeOrder() {
 const [order, setOrder] = useState(DEFAULT_ORDER);

 useEffect(() => {
  let cancelled = false;
  axios.get(`${API}/api/cms/home-order`)
   .then(r => {
    const o = r?.data?.order;
    if (!cancelled && Array.isArray(o) && o.length === DEFAULT_ORDER.length) {
     setOrder(o);
    }
   })
   .catch(() => { /* keep DEFAULT_ORDER */ });
  return () => { cancelled = true; };
 }, []);

 return order;
}
